import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Typography,
  Paper,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  IconButton,
  FormControlLabel,
  Checkbox,
  DialogTitle,
} from '@mui/material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { RemoveCircleOutline } from '@mui/icons-material';
import { format } from 'date-fns';
import BackButton from './BackButton';
import UnversalSpinner from './CommonUtilites/UniversalSpinner';
import axiosAPIinstance from '../config/axiosAPIinstance';

const weightOptions = ['100g', '250g', '500g', '1kg', '100ml', '250ml', '500ml', '1L', 'Enter Manually'];

function AddItemForm() {

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [weights, setWeights] = useState([
    {
      weight: '',
      mrp: '',
      costPrice: '',
      sellingPriceWithGST: '',
      sellingPrice: '',
      discountPercent: '',
      gstPercent: '',
      gstPrice: '',
      skuBarCode: '',
      availableStock: '',
      minPurchaseQty: '',
      maxPurchaseQty: '',
      dimensions: '',
      availabilityStatus: '',
      returnable: '',
      color: '',
    },
  ]);

  const [item, setItem] = useState({
    productName: '',
    recommend: '',
    hsCodeBarCode: '',
    brand: '',
    category: '',
    pureVeg: '',
    warrantyInfo: '',
    returnPolicy: '',
    manufacturer: '',
    modelNumber: '',
    tags: '',
    labels: '',
    countryOfOrigin: '',
    description: '',
    image: null,
    additionalImages: [],
    purchaseDate: format(new Date(), "yyyy-MM-dd"),
    expiryDate: format(new Date(), "yyyy-MM-dd"),
  });

  const [errors, setErrors] = useState({});
  const [response, setResponse] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [additionalImagePreviews, setAdditionalImagePreviews] = useState([]);
  const [imgError, setImgError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [dynamicWeightOptions, setDynamicWeightOptions] = useState(weightOptions);
  const [openWeightModal, setOpenWeightModal] = useState(false);
  const [selectedWeightIndex, setSelectedWeightIndex] = useState(null);
  const [manualWeightValue, setManualWeightValue] = useState('');
  const [showCalculateButton, setShowCalculateButton] = useState(true);

  const formatFloat = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    setItem((prevItem) => ({
      ...prevItem,
      [name]: newValue,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setItem({ ...item, image: file });
    setImagePreview(URL.createObjectURL(file));
    setImgError(true);
  };

  const handleAdditionalFilesChange = (e) => {
    const files = Array.from(e.target.files);
    setItem({ ...item, additionalImages: files });
    setAdditionalImagePreviews(files.map((file) => URL.createObjectURL(file)));
    setImgError(true);
  };

  const handleWeightChange = (index, field, value) => {
    const updatedWeights = [...weights];
    updatedWeights[index][field] = value;
    setWeights(updatedWeights);
    setShowCalculateButton(true);
  };

  // const handleCalculate = (index) => {
  //   const weight = weights[index];
  //   const mrp = parseFloat(weight.mrp) || 0;
  //   const gstPercent = parseFloat(weight.gstPercent) || 0;
  //   const sellingPriceWithGST = parseFloat(weight.sellingPriceWithGST) || 0;
  //   let basePrice = 0;
  //   let gstAmount = 0;
  //   let discount = 0;
  //   if (gstPercent > 0) {
  //     if (sellingPriceWithGST > 0) {
  //       basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
  //     } else {
  //       basePrice = mrp;
  //     }
  //     gstAmount = basePrice * (gstPercent / 100);
  //     discount = ((mrp - basePrice) / mrp) * 100;
  //     weight.sellingPrice = formatFloat(basePrice);
  //     weight.gstPrice = formatFloat(gstAmount);
  //     if (!weight.sellingPriceWithGST) {
  //       weight.sellingPriceWithGST = formatFloat(basePrice + gstAmount);
  //     }
  //     weight.discountPercent = Math.round(formatFloat(discount));
  //   } else {
  //     basePrice = sellingPriceWithGST > 0 ? sellingPriceWithGST : mrp;
  //     weight.sellingPrice = formatFloat(basePrice);
  //     weight.gstPrice = formatFloat(0);
  //     weight.gstPercent = formatFloat(0);
  //     discount = ((mrp - basePrice) / mrp) * 100;
  //     weight.discountPercent = formatFloat(discount);
  //     if (!weight.sellingPriceWithGST) {
  //       weight.sellingPriceWithGST = formatFloat(basePrice);
  //     }
  //   }
  //   const updatedWeights = [...weights];
  //   updatedWeights[index] = weight;
  //   setWeights(updatedWeights);
  //   setShowCalculateButton(false);
  // };

  const handleCalculate = (index) => {
  const weight = weights[index];
  const mrp = parseFloat(weight.mrp) || 0;
  const gstPercent = parseFloat(weight.gstPercent) || 0;
  let sellingPriceWithGST = parseFloat(weight.sellingPriceWithGST) || 0;
  let basePrice = 0;
  let gstAmount = 0;
  let discount = 0;

  if (gstPercent > 0) {
    // Calculate basePrice
    if (sellingPriceWithGST > 0) {
      basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
    } else {
      basePrice = mrp;
    }

    // Ensure sellingPriceWithGST is valid (between basePrice and MRP)
    const minSellingPriceWithGST = basePrice; // basePrice + GST (but GST could be 0)
    const maxSellingPriceWithGST = mrp * (1 + gstPercent / 100); // MRP + GST

    if (sellingPriceWithGST <= 0 || sellingPriceWithGST < minSellingPriceWithGST) {
      sellingPriceWithGST = minSellingPriceWithGST;
    } else if (sellingPriceWithGST > maxSellingPriceWithGST) {
      sellingPriceWithGST = maxSellingPriceWithGST;
    }

    // Recalculate basePrice if sellingPriceWithGST was adjusted
    basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
    gstAmount = basePrice * (gstPercent / 100);
    discount = ((mrp - basePrice) / mrp) * 100;

    weight.sellingPrice = formatFloat(basePrice);
    weight.gstPrice = formatFloat(gstAmount);
    weight.sellingPriceWithGST = formatFloat(sellingPriceWithGST);
    weight.discountPercent = Math.round(formatFloat(discount));
  } else {
    // GST is 0%, so sellingPriceWithGST = basePrice
    basePrice = sellingPriceWithGST > 0 ? sellingPriceWithGST : mrp;

    // Ensure sellingPriceWithGST is between basePrice and MRP
    if (sellingPriceWithGST <= 0 || sellingPriceWithGST < basePrice) {
      sellingPriceWithGST = basePrice;
    } else if (sellingPriceWithGST > mrp) {
      sellingPriceWithGST = mrp;
    }

    // Reassign basePrice if sellingPriceWithGST was adjusted
    basePrice = sellingPriceWithGST;
    discount = ((mrp - basePrice) / mrp) * 100;

    weight.sellingPrice = formatFloat(basePrice);
    weight.gstPrice = formatFloat(0);
    weight.gstPercent = formatFloat(0);
    weight.sellingPriceWithGST = formatFloat(basePrice);
    weight.discountPercent = formatFloat(discount);
  }

  const updatedWeights = [...weights];
  updatedWeights[index] = weight;
  setWeights(updatedWeights);
  setShowCalculateButton(false);
};

  const addWeightField = () => {
    setWeights([
      ...weights,
      {
        weight: '',
        mrp: '',
        costPrice: '',
        sellingPriceWithGST: '',
        sellingPrice: '',
        discountPercent: '',
        gstPercent: '',
        gstPrice: '',
        skuBarCode: '',
        availableStock: '',
        minPurchaseQty: '',
        maxPurchaseQty: '',
        dimensions: '',
        availabilityStatus: '',
        returnable: '',
        color: '',
      },
    ]);
  };

  const removeWeightField = (index) => {
    setWeights(weights.filter((_, i) => i !== index));
  };

  const handleDateChange = (name, date) => {
    const formattedDate = format(date, "yyyy-MM-dd");
    setItem({ ...item, [name]: formattedDate });
  };

  const handleManualWeightSubmit = () => {
    if (selectedWeightIndex !== null && manualWeightValue) {
      handleWeightChange(selectedWeightIndex, 'weight', manualWeightValue);
      if (!dynamicWeightOptions.includes(manualWeightValue)) {
        setDynamicWeightOptions([manualWeightValue, ...dynamicWeightOptions]);
      }
    }
    setManualWeightValue('');
    setOpenWeightModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.keys(item).forEach((key) => {
      if (item[key] instanceof File) {
        formData.append(key, item[key]);
      } else if (Array.isArray(item[key])) {
        item[key].forEach((file) => {
          if (file instanceof File) {
            formData.append(key, file);
          }
        });
      } else {
        formData.append(key, item[key]);
      }
    });

    formData.append('productVarients', JSON.stringify(weights));

    try {
      setLoading(true);
      const response = await axiosAPIinstance.post('/product/addNewProduct', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        secure: true
      });
      setResponse(response.data);
      setLoading(false);
      setOpenModal(true);
      resetForm();
    } catch (error) {
      console.error('Error adding item:', error);
      setResponse('Error adding item. Please try again.');
      setLoading(false);
    }
  };

  const resetForm = () => {
    setItem({
      productName: '',
      recommend: '',
      hsCodeBarCode: '',
      brand: '',
      category: '',
      pureVeg: '',
      warrantyInfo: '',
      returnPolicy: '',
      manufacturer: '',
      modelNumber: '',
      tags: '',
      labels: '',
      countryOfOrigin: '',
      description: '',
      image: null,
      additionalImages: [],
      purchaseDate: format(new Date(), "yyyy-MM-dd"),
      expiryDate: format(new Date(), "yyyy-MM-dd"),
    });
    setWeights([
      {
        weight: '',
        mrp: '',
        costPrice: '',
        sellingPriceWithGST: '',
        sellingPrice: '',
        discountPercent: '',
        gstPercent: '',
        gstPrice: '',
        skuBarCode: '',
        availableStock: '',
        minPurchaseQty: '',
        maxPurchaseQty: '',
        dimensions: '',
        availabilityStatus: '',
        returnable: '',
        color: '',
      },
    ]);
    setImagePreview(null);
    setAdditionalImagePreviews([]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    axiosAPIinstance.get('/categories')
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" padding={3}>
      <Paper elevation={3} style={{ padding: '30px', width: '90%' }}>
        <Typography variant="h5" align="center" gutterBottom>
          Add New Product
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} margin={1} width={'95%'}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="productName"
                label="Product Name"
                fullWidth
                required
                value={item.productName}
                onChange={handleInputChange}
                error={!!errors.productName}
                helperText={errors.productName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="hsCodeBarCode"
                label="HSCode/Barcode"
                fullWidth
                value={item.hsCodeBarCode}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="brand"
                label="Brand"
                fullWidth
                required
                value={item.brand}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Category</InputLabel>
                <Select
                  name="category"
                  value={item.category}
                  onChange={handleInputChange}
                  label="Category"
                >
                  {categories.map((category) => (
                    <MenuItem key={category.id} value={category.name}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Is PureVeg</InputLabel>
                <Select
                  name="pureVeg"
                  value={item.pureVeg}
                  onChange={handleInputChange}
                  label="Is PureVeg"
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="recommend"
                    checked={item.recommend}
                    onChange={handleInputChange}
                    color="primary"
                  />
                }
                label="Recommend"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="returnPolicy"
                label="Return Policy"
                fullWidth
                value={item.returnPolicy}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="tags"
                label="Tags"
                fullWidth
                value={item.tags}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="labels"
                label="Labels"
                fullWidth
                value={item.labels}
                onChange={handleInputChange}
              />
            </Grid>

            
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Purchase Date"
                  value={item.purchaseDate}
                  required
                  onChange={(date) => handleDateChange('purchaseDate', date)}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Expiry Date"
                  value={item.expiryDate}
                  required
                  onChange={(date) => handleDateChange('expiryDate', date)}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </LocalizationProvider>
            </Grid>

            {weights.map((weight, index) => (
              <Grid container spacing={2} margin={1} padding={1} key={index} style={{ border: '2px solid lightgray', borderRadius: '10px' }}>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth required>
                    <InputLabel>Weight</InputLabel>
                    <Select
                      value={weight.weight}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === 'Enter Manually') {
                          setSelectedWeightIndex(index);
                          setOpenWeightModal(true);
                        } else {
                          handleWeightChange(index, 'weight', value);
                        }
                      }}
                      label="Weight"
                    >
                      {dynamicWeightOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          <ListItemText primary={option} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="MRP"
                    type="number"
                    fullWidth
                    required
                    value={weight.mrp}
                    onChange={(e) => handleWeightChange(index, 'mrp', e.target.value)}
                    onBlur={(e) => handleWeightChange(index, 'mrp', formatFloat(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="SP_With_GST"
                    type="number"
                    fullWidth
                    required
                    value={weight.sellingPriceWithGST}
                    onChange={(e) => handleWeightChange(index, 'sellingPriceWithGST', e.target.value)}
                    onBlur={(e) => handleWeightChange(index, 'sellingPriceWithGST', formatFloat(e.target.value))}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    label="GST %"
                    type="number"
                    fullWidth
                    required
                    value={weight.gstPercent}
                    onChange={(e) => handleWeightChange(index, 'gstPercent', e.target.value)}
                    onBlur={(e) => handleWeightChange(index, 'gstPercent', formatFloat(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="Discount %"
                    type="number"
                    fullWidth
                    required
                    disabled
                    value={weight.discountPercent}
                    onChange={(e) => handleWeightChange(index, 'discountPercent', e.target.value)}
                    onBlur={(e) => handleWeightChange(index, 'discountPercent', formatFloat(e.target.value))}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="Selling Price"
                    type="number"
                    fullWidth
                    disabled
                    value={weight.sellingPrice}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="GST Price/Value"
                    type="number"
                    fullWidth
                    disabled
                    value={weight.gstPrice}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="MinPurchaseQty"
                    type="number"
                    fullWidth
                    required
                    value={weight.minPurchaseQty}
                    onChange={(e) => handleWeightChange(index, 'minPurchaseQty', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    label="MaxPurchaseQty"
                    type="number"
                    fullWidth
                    required
                    value={weight.maxPurchaseQty}
                    onChange={(e) => handleWeightChange(index, 'maxPurchaseQty', e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    label="Available Stock"
                    type="number"
                    fullWidth
                    required
                    value={weight.availableStock}
                    onChange={(e) => handleWeightChange(index, 'availableStock', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth required>
                    <InputLabel id="availability-status-label">Availability Status</InputLabel>
                    <Select
                      value={weight.availabilityStatus}
                      onChange={(e) => handleWeightChange(index, 'availabilityStatus', e.target.value)}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth required>
                    <InputLabel id="returnable-status-label">Is Returnable</InputLabel>
                    <Select
                      value={weight.returnable}
                      onChange={(e) => handleWeightChange(index, 'returnable', e.target.value)}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    label="SKU Barcode"
                    fullWidth
                    value={weight.skuBarCode}
                    onChange={(e) => handleWeightChange(index, 'skuBarCode', e.target.value)}
                  />
                </Grid>

                {showCalculateButton && (
                  <Button
                    variant="contained"
                    onClick={() => handleCalculate(index)}
                    style={{ margin: '16px' }}
                  >
                    Calculate
                  </Button>
                )}

                <Grid item xs={12} sm={2}>
                  <IconButton onClick={() => removeWeightField(index)} color="error">
                    <RemoveCircleOutline />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Grid item xs={12} sm={3}>
              <Button onClick={addWeightField} variant="outlined" fullWidth>
                Add More Varients
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="description"
                label="Description"
                multiline
                rows={4}
                fullWidth
                value={item.description}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button variant="contained" component="label" fullWidth style={{ backgroundColor: imgError && item.image ? '' : 'red', margin: '1rem 0rem' }}>
                Upload Image
                <input type="file" hidden name="image" onChange={handleFileChange} required />
              </Button>
            </Grid>
            {imagePreview && (
              <Grid item xs={12}>
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{ width: '250px', maxHeight: '250px', objectFit: 'cover', borderRadius: '8px' }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <Button variant="contained" component="label" fullWidth style={{ backgroundColor: imgError && item.additionalImages.length > 0 ? '' : 'red', margin: '1rem 0rem' }}>
                Upload Additional Images
                <input type="file" hidden multiple name="additionalImages" onChange={handleAdditionalFilesChange} />
              </Button>
            </Grid>
            {additionalImagePreviews.length > 0 && (
              <Grid item xs={12}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {additionalImagePreviews.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt="Additional Preview"
                      style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }}
                    />
                  ))}
                </div>
              </Grid>
            )}
          </Grid>
          {loading && <UnversalSpinner />}
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </form>

        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>Submission Result</DialogTitle>
          <DialogContent>
            {response.success ? (
              <Typography style={{ color: 'green' }}>{response.message}</Typography>
            ) : (
              <Typography style={{ color: 'red' }}>{response.message}</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Manual Weight Entry Modal */}
        <Dialog open={openWeightModal} onClose={() => setOpenWeightModal(false)}>
          <DialogTitle>Enter Weight Manually</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Weight"
              type="text"
              fullWidth
              variant="standard"
              value={manualWeightValue}
              onChange={(e) => setManualWeightValue(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleManualWeightSubmit()}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenWeightModal(false)}>Cancel</Button>
            <Button onClick={handleManualWeightSubmit}>Submit</Button>
          </DialogActions>
        </Dialog>

        <div className="indent-container">
          <BackButton />
        </div>
      </Paper>
    </Box>
  );
}

export default AddItemForm;
